
import ClubJoinActivator from '~/components/organisms/clubs/ClubJoinActivator.vue'

export default {
  components: { ClubJoinActivator },
}
